'use client'
import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { useCallback } from 'react';
import { authenticatePasskeyMFA } from '@dynamic-labs-sdk/client';
import { useDynamicClient } from '../../../client/client.js';

/**
 * Authenticate passkey for MFA
 *
 * @returns Function to authenticate with a passkey for MFA
 *
 * @example
 * ```tsx
 * const App = () => {
 *   const authenticatePasskeyMFA = useAuthenticatePasskeyMFA();
 *
 *   // Optional: creates a single-use MFA token
 *   const createMfaToken = { singleUse: true };
 *
 *   return (
 *     <button
 *       onClick={() => authenticatePasskeyMFA({ createMfaToken })}
 *     >
 *       Authenticate passkey
 *     </button>
 *  );
 * }
 */
const useAuthenticatePasskeyMFA = () => {
    const client = useDynamicClient();
    return useCallback((props) => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield authenticatePasskeyMFA(client, props);
        return result.mfaToken;
    }), [client]);
};

export { useAuthenticatePasskeyMFA };
